// src/pages/Testimonials.js
import './Testimonials.css';

export default function Testimonials() {
  const testimonials = [
    {
      name: 'Aditi Sharma',
      quote: 'I absolutely love my wedding album! The quality is amazing and the layout is beautiful.',
      image: '/assets/review1.avif',
    },
    {
      name: 'Rohan Mehta',
      quote: 'Creating a travel photobook was so easy. Now I can relive my trips anytime!',
      image: '/assets/review2.avif',
    },
    {
      name: 'Sneha Patil',
      quote: 'Ordered a baby photo book as a gift—my sister cried happy tears. Highly recommend!',
      image: '/assets/review3.avif',
    },
  ];

  const faqs = [
    {
      question: 'How long does it take to print a photobook?',
      answer: 'Typically 2-4 working days, depending on customization and order volume.',
    },
    {
      question: 'Do you offer doorstep delivery?',
      answer: 'Yes, we ship pan-India with tracking and safe packaging.',
    },
    {
      question: 'Can I make changes to my design after submission?',
      answer: 'Yes, we allow one round of revisions before printing.',
    },
  ];

  return (
    <div className="testimonials-container">
      <h1>What Our Customers Say</h1>
      <p className="intro">
        Hear directly from our happy customers who’ve preserved their memories with us.
      </p>

      <div className="testimonial-grid">
        {testimonials.map((item, index) => (
          <div className="testimonial-card" key={index}>
            <img src={item.image} alt={item.name} />
            <p className="quote">“{item.quote}”</p>
            <p className="name">— {item.name}</p>
          </div>
        ))}
      </div>
      <div className="testimonial-videos">
        <div className="video-grid">
          <div className="video-wrapper">
            <iframe
              width="100%"
              height="250"
              src="https://www.youtube.com/embed/ThNzdcseePs"
              title="Customer Testimonial 1"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <div className="video-wrapper">
            <iframe
              width="100%"
              height="250"
              src="https://www.youtube.com/embed/HawRnirzCsM"
              title="Customer Testimonial 2"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          {/* Add more video wrappers as needed */}
        </div>
      </div>

      {/* Trust Review Badge */}
      <div className="review-badge">
        <a
          href="https://www.google.com/search?sca_esv=30db70402d7c8856&rlz=1C5CHFA_enIE1027IE1034&tbm=lcl&sxsrf=AE3TifNBlidpdT1DSdKKOGJoVcgsJW6a6A:1752834930956&q=WePrint+PhotoBooks+Reviews&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIyMTYwtTAzMTc2szAxMzQ0MzfewMj4ilEqPDWgKDOvRCEgI78k3yk_P7tYISi1LDO1vHgRKx5JAMXZ2DtTAAAA&rldimm=430586473684611673&hl=en-IE&sa=X&ved=2ahUKEwinjqP7msaOAxWFXUEAHaDzJnYQ9fQKegQIPxAF&biw=1470&bih=713&dpr=2#lkt=LocalPoiReviews"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/assets/greview.png" // or use an online version
            alt="Rated Excellent on Google Reviews"
          />
        </a>
        <p className="badge-caption">Rated 4.9 ★★★★★ by 340+ happy customers</p>
      </div>

      {/* FAQ Section */}
      <div className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-grid">
          {faqs.map((faq, i) => (
            <div className="faq-item" key={i}>
              <h4>{faq.question}</h4>
              <p>{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
